import $ from 'jquery';
import { debounce } from '../../helper/debounce';

const calcHeaderHeight = () => {
	const el = {
		target: '.elementor-location-header',
	};

	const init = () => {
		$(function () {
			if (!$(el.target).length) return;
			exec();
			$(window).on('resize', debounce(exec, 200));
		});
	};

	const exec = () => {
		$('body').css(
			'--header-height',
			Math.ceil($(el.target).height()) + 'px',
		);
	};

	init();
};

try {
	calcHeaderHeight();
} catch (error) {
	console.error(error);
}
